import { ZodType } from "zod";

// Ensures a schema stays assignable to an existing model type.
export const typedSchema =
  <T>() =>
  <S extends ZodType<T>>(schema: S) =>
    schema;
